<template>
	<div>
		<van-nav-bar
			title="用户使用说明"
			left-text="返回"
			left-arrow
			@click-left="onClickLeft"
		/>
		<van-cell center>
			<!-- 使用 title 插槽来自定义标题 -->
			<template #title>
				<img
					class="avanta"
					width="100%"
					height="100%"
					v-bind:src="headImgUrl"
				/>
			</template>
		</van-cell>
	</div>
</template>

<script>
import {
	Cell,
	CellGroup,
	NavBar,
	Image as VanImage,
	Popup,
	Grid,
	GridItem,
	Col,
	Row,
	Button,
	Toast,
} from "vant";

export default {
	components: {
		[Cell.name]: Cell,
		[CellGroup.name]: CellGroup,
		[NavBar.name]: NavBar,
		[VanImage.name]: VanImage,
		[Popup.name]: Popup,
		[Grid.name]: Grid,
		[GridItem.name]: GridItem,
		[Col.name]: Col,
		[Row.name]: Row,
		[Button.name]: Button,
		[Toast.name]: Toast,
	},
	data: function() {
		return {
			headImgUrl: "/images/userreference.jpg",
		};
	},
	mounted: function() {},
	created: function() {},
	methods: {
		onClickLeft: function() {
			this.$router.push({ name: "home" });
		},
	},
};
</script>

<style lang="less"></style>
